export default __webpack_public_path__ + "static/media/gptlogo.1dc0fded.png";